<template>
  <div>
    <staff-vacation-request-button
      v-if="!isManager"
      :staff-id="staffId"
      @update-table="updateTable"
    />

    <staff-vacation-tracker-table
      :key="`vacation-table-${updateKey}`"
      :staff-id="staffId"
      leave-type="vacation"
    />

    <staff-vacation-tracker-table
      :key="`sick-leave-table-${updateKey}`"
      :staff-id="staffId"
      leave-type="sick_leave"
    />
  </div>
</template>

<script>

export default {
    name: "StaffVacationTracker",
    props: {
        staffId: {
            type: Number,
            required: true,
        },
        managerId: {
            type: Number,
            required: false,
            default: null,
        },
        leaveType: {
            type: String,
            required: false,
            default: "vacation",
        },
    },
    data: function() {
        return {
            updateKey: 0,
        };
    },
    computed: {
        isManager() {
            return this.managerId !== null;
        },
    },
    methods: {
        updateTable() {
            this.updateKey++;
        },
    },
};
</script>

<style scoped>

</style>
